import React, {useState} from "react";
import TradingFAQ01 from "../../../../static/img/FAQ/Eye_open.svg";
import TradingFAQ01Active from "../../../../static/img/FAQ/Eye_openActive.svg";
import TradingFAQ02 from "../../../../static/img/FAQ/Eye_close.svg";
import TradingFAQ02Active from "../../../../static/img/FAQ/Eye_closeActive.svg";
let ButtonVisibleAllLet = 'TradingFAQButtonButtonAllDivActiveNo';
let ButtonVisibleNoLet = 'TradingFAQButtonButtonAllDivActive';

function FAQElements(props){
    console.log('FAQElements',)
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}

    const [stateArrayFAQ, setstateArrayFAQ] = useState(props.AllFAQElements);
    const [VisibleCloseButton, setVisibleCloseButton] = useState(ButtonVisibleAllLet);
    const [VisibleOpenButton, setVisibleOpenButton] = useState(ButtonVisibleNoLet);
    const [forRerender, setRerender] = useState('');

    function FAQCategory(AllFAQCatArr) {

        const listItemsCat = Object.keys(AllFAQCatArr).map((number) =>
            <div key={number}>
                <div className={"TradingFAQPartTitle"}>{JSON.parse(AllFAQCatArr[number].Name)[props.lang].toUpperCase()}</div>
                {FAQElement(stateArrayFAQ,AllFAQCatArr[number].Elements)}
            </div>
        );
        return (
            <div className="FAQElementCategory">{listItemsCat}</div>

        )}

    function FAQElement(AllFAQArr,Elements) {
        const listItems = Elements.map((number) =>
            <div key={number._id}>
                <div className={"TradingFAQPartElement "+ (stateArrayFAQ[number._id] ? 'TradingFAQPartElementActive' : '')} onClick={() => MakeVisibleThis(number._id)} role="button" tabIndex={0}>
                    <span className="TradingFAQPartElementTitle">{JSON.parse(number.Title)[props.lang]}</span>
                    <div className="TradingFAQPartElementText">{JSON.parse(number.Text)[props.lang]}</div>
                </div>
            </div>
        );
        return (
            <div className="FAQElementText">{listItems}</div>
        )}

    function MakeVisibleAll() {
        const MakeVisibleThisArr = stateArrayFAQ;
        for (let i = 0; i < Object.keys(stateArrayFAQ).length; i++) {
            MakeVisibleThisArr[Object.keys(stateArrayFAQ)[i]] = true;
        }
        ButtonVisibleAllLet = 'TradingFAQButtonButtonAllDivActiveNo';
        ButtonVisibleNoLet = 'ButtonBlueFAQ';
        setstateArrayFAQ(MakeVisibleThisArr);
        setVisibleOpenButton(ButtonVisibleAllLet);
        setVisibleCloseButton(ButtonVisibleNoLet);
    }

    function MakeVisibleNo() {
        const MakeVisibleThisArr = stateArrayFAQ;
        for (let i = 0; i < Object.keys(stateArrayFAQ).length; i++) {
            MakeVisibleThisArr[Object.keys(stateArrayFAQ)[i]] = false;
        }
        ButtonVisibleAllLet = 'ButtonBlueFAQ';
        ButtonVisibleNoLet = 'TradingFAQButtonButtonAllDivActiveNo';
        setstateArrayFAQ(MakeVisibleThisArr);
        setVisibleOpenButton(ButtonVisibleAllLet);
        setVisibleCloseButton(ButtonVisibleNoLet);
    }

    function MakeVisibleThis(idActive) {
        // console.log('idActive',idActive);
        setRerender(!forRerender);

        const MakeVisibleThisArr = stateArrayFAQ;
        MakeVisibleThisArr[idActive] = !MakeVisibleThisArr[idActive];
        // for (let i = 0; i < stateArrayFAQ.length; i++) {
        //     if (MakeVisibleThisArr[i]._id === idActive) {
        //         if (MakeVisibleThisArr[i].classActive !== 'TradingFAQPartElementActive') {MakeVisibleThisArr[i].classActive  = 'TradingFAQPartElementActive'} else {MakeVisibleThisArr[i].classActive  = ''}
        //     }}

        let check = false;
        let ButtonVisibleAllLet = 'ButtonBlueFAQ';
        let ButtonVisibleNoLet = 'ButtonBlueFAQ';
        for (let i = 0; i < Object.values(MakeVisibleThisArr).length; i++) {
            if (Object.values(MakeVisibleThisArr)[i]) {check = true}
        }
        if (!check) {ButtonVisibleNoLet = 'TradingFAQButtonButtonAllDivActiveNo'}

        check = false;
        for (let i = 0; i < Object.values(MakeVisibleThisArr).length; i++) {
            if (Object.values(MakeVisibleThisArr)[i]) {check = true}
        }
        if (!check) {ButtonVisibleAllLet = 'TradingFAQButtonButtonAllDivActiveNo'}
        setstateArrayFAQ(MakeVisibleThisArr);
        setVisibleOpenButton(ButtonVisibleAllLet);
        setVisibleCloseButton(ButtonVisibleNoLet);
    }

        return (
            <main className="TradingFAQOut  StandartPage">
                <div className="TraderFAQ">

                    <div className="StandartPage ">
                            <div className="TitleGlobalFlex">
                                <div className="StandartTitle">FAQ</div>
                                <div className={"TradingFAQButtonButtonAll TradingFAQButtonButtonAll"+(props.lang === 'en' ? 'EnglishVersion' : '')}>
                                    <div className={VisibleOpenButton} role = "button" tabIndex={0} onClick={() => MakeVisibleAll()}>
                                        <img alt='Ifyoudontseeimages' src={TradingFAQ01} width='18px' className="TradingFAQIMG"/>
                                        <img alt='Ifyoudontseeimages' src={TradingFAQ01Active} width='18px' className="TradingFAQIMGActive"/>
                                        <nobr><TextSource ArrIndex= 'PageTradingFAQ0010'>Открыть все</TextSource></nobr>
                                    </div>
                                    <div className={VisibleCloseButton} role = "button" tabIndex={0} onClick={() => MakeVisibleNo()}>
                                        <img alt='Ifyoudontseeimages' src={TradingFAQ02} width='18px' className="TradingFAQIMG"/>
                                        <img alt='Ifyoudontseeimages' src={TradingFAQ02Active} width='18px' className="TradingFAQIMGActive"/>
                                        <nobr><TextSource ArrIndex= 'PageTradingFAQ0015'>Закрыть все</TextSource></nobr>
                                    </div>
                                </div>
                            </div>
                            <div className="TradingFAQPart">{FAQCategory(props.AllFAQCategories)}</div>
                    </div>
                </div>
            </main>
        )}

export default FAQElements